/** Ephemeral account selector consumed and removed during app bootstrap. */
export const ACCOUNT_PARAM = 'pplx_account';
//# sourceMappingURL=constants.js.map